
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as gZ0iGNRMoCoUsaGUkR9jDROejRkPAzVgRoAgckhdHLbgMeta } from "/codebuild/output/src1149751735/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue?macro=true";
import { default as indexsdBenc_45ZUvSKoqDxyRtAM00tVyWvpJlvwDE6W3UF17EMeta } from "/codebuild/output/src1149751735/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue?macro=true";
import { default as searchZVK8nTv8tpxsUwbs52amqx13HSpy1kosNvHj1dQnqusMeta } from "/codebuild/output/src1149751735/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue?macro=true";
import { default as indexxzhRJr73IDmU3hMem2nh71dMqVIr0qzQSZkXp_OHjjgMeta } from "/codebuild/output/src1149751735/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue?macro=true";
import { default as _91id_93l_45yJGQYmQniiMxHMLQrVmechUib8vpxz7J_mMhu_45BVAMeta } from "/codebuild/output/src1149751735/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue?macro=true";
import { default as indexOaeGd_45H5SdQvhrKm9B2F8mQ9jzqBciBaEU8_214dQvUMeta } from "/codebuild/output/src1149751735/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue?macro=true";
import { default as _91id_93qXFc1paM8Medi_2ToQ3_Hu3A8ButLin8QAIi8HROvGoMeta } from "/codebuild/output/src1149751735/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue?macro=true";
import { default as indexzMngoryRGawLwFBZSSlS7vr5kX8OXBLGnaD737ua8JMMeta } from "/codebuild/output/src1149751735/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue?macro=true";
import { default as _91id_93Y9A1w0bLct_Rk_fiy4sH1dQuxPIg5J6F2jTvccGGwMQMeta } from "/codebuild/output/src1149751735/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue?macro=true";
import { default as indexmZC_45R1q7lonMAEQIIKp3W6ygpiqqVsPogzh7vWYzqyoMeta } from "/codebuild/output/src1149751735/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue?macro=true";
import { default as indexhRXb0MjM7Z_45L58n07hrdGSQBdjHYlSRPo1VNmsjkbX8Meta } from "/codebuild/output/src1149751735/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue?macro=true";
export default [
  {
    name: "g",
    path: "/g",
    component: () => import("/codebuild/output/src1149751735/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/codebuild/output/src1149751735/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue")
  },
  {
    name: "search",
    path: "/search",
    component: () => import("/codebuild/output/src1149751735/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue")
  },
  {
    name: "v8",
    path: "/v8",
    component: () => import("/codebuild/output/src1149751735/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue")
  },
  {
    name: "video-id",
    path: "/video/:id()",
    component: () => import("/codebuild/output/src1149751735/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue")
  },
  {
    name: "terms",
    path: "/terms",
    meta: indexOaeGd_45H5SdQvhrKm9B2F8mQ9jzqBciBaEU8_214dQvUMeta || {},
    component: () => import("/codebuild/output/src1149751735/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue")
  },
  {
    name: "article-id",
    path: "/article/:id()",
    component: () => import("/codebuild/output/src1149751735/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue")
  },
  {
    name: "contact",
    path: "/contact",
    meta: indexzMngoryRGawLwFBZSSlS7vr5kX8OXBLGnaD737ua8JMMeta || {},
    component: () => import("/codebuild/output/src1149751735/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue")
  },
  {
    name: "v8-article-id",
    path: "/v8/article/:id()",
    component: () => import("/codebuild/output/src1149751735/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue")
  },
  {
    name: "privacy-policy",
    path: "/privacy-policy",
    meta: indexmZC_45R1q7lonMAEQIIKp3W6ygpiqqVsPogzh7vWYzqyoMeta || {},
    component: () => import("/codebuild/output/src1149751735/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue")
  },
  {
    name: "privacy-policy-relationships",
    path: "/privacy-policy/relationships",
    meta: indexhRXb0MjM7Z_45L58n07hrdGSQBdjHYlSRPo1VNmsjkbX8Meta || {},
    component: () => import("/codebuild/output/src1149751735/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue")
  }
]